import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    // Allow access to register/login pages regardless of auth state
    // Users can re-login or create new accounts
    return this.authService.isAuthenticated$.pipe(
      take(1),
      map(isAuthenticated => {
        // Allow navigation to auth pages even if authenticated
        return true;
      })
    );
  }
}
